import { useAtom } from 'jotai';
import useTypeTracking from '../analytics';
import useIsMobile from '../hooks/useIsMobile';
import { useDrawerContentAtom, useDrawerStateAtom } from '../Layout/Navigation/Drawer/atoms';
import { DrawerNav } from '../Layout/Navigation/Drawer/DrawerContent/const';
import {
    currentSettingViewAtom,
    SettingsPage,
    userModalStateAtom,
} from '../people/UserSettings/atom';

export const useUserSettings = () => {
    const isMobile = useIsMobile();
    const [userModalStatus, setModalState] = useAtom(userModalStateAtom);
    const [currentView, changeCurrentView] = useAtom(currentSettingViewAtom);
    const { setDrawerState } = useDrawerStateAtom();
    const { setDrawerContent } = useDrawerContentAtom();
    const { trackClickEvent } = useTypeTracking({ data: { category: 'SETTINGS' } });

    const openSettings = ({
        modalState,
        drawerState,
    }: {
        drawerState?: DrawerNav;
        modalState?: SettingsPage;
    }) => {
        if (isMobile) {
            setDrawerState(true);
            setDrawerContent(drawerState);
        } else {
            enableModal();
            changeCurrentView(modalState);
        }
    };

    const enableModal = () => {
        if (!userModalStatus) {
            setModalState(true);
        }
    };

    const openUserProfile = () => {
        openSettings({
            drawerState: DrawerNav.MY_PROFILE_CONTENT,
            modalState: SettingsPage.ProfilePreferences,
        });
        trackClickEvent({
            subCategory: 'OPEN_PROFILE_SETTINGS',
        });
    };

    const openScheduledMeetings = () => {
        openSettings({
            drawerState: DrawerNav.MEETINGS_CONTENT,
            modalState: SettingsPage.SchedulingPreferences,
        });
        trackClickEvent({
            subCategory: 'OPEN_MEETING_SETTINGS',
        });
    };

    const closeUserSettings = () => {
        setModalState(false);
        changeCurrentView(SettingsPage.ProfilePreferences);
    };

    return {
        userModalStatus,
        currentView,
        openUserProfile,
        openScheduledMeetings,
        closeUserSettings,
    };
};
